import { forwardRef, type SelectHTMLAttributes } from "react";

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean;
}

/** Native select with a themed chevron (the `select-field` class in index.css). */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { invalid = false, className = "", children, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      aria-invalid={invalid || undefined}
      className={`select-field h-11 w-full rounded-control border bg-board py-0 pr-9 pl-3 text-operate text-ink disabled:bg-ice-2 ${invalid ? "border-red" : "border-edge"} ${className}`}
      {...rest}
    >
      {children}
    </select>
  );
});
